<template>
  <app-page :title="$t('@debtsList/title')" wide>
    <v-flex shrink slot="actions" class="date-picker">
      <div class="date-title">{{ $t('@debtsList/createdFromFilterDatepickerLabel') }}</div>
      <v-menu
        ref="modal"
        v-model="dateModal"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            color="green"
            v-model="dateFormatted"
            readonly
            prepend-icon="event"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="date"
          color="green"
          no-title
          @input="dateModal = false"
        ></v-date-picker>
      </v-menu>
    </v-flex>

    <v-layout>
      <v-flex xs12>
        <debt-list
          ref="list"
          :filters="params"
          :headers="translatedHeaders"
          :pickerDate="date"
          @beforeRequest="onBeforeRequest"
        />
      </v-flex>
    </v-layout>
  </app-page>
</template>

<script>
import moment from 'moment';
import DebtList, { defaultHeaders } from './DebtList';

export default {
  components: { DebtList },
  data() {
    return {
      params: {
        from: moment()
          .subtract(1, 'month')
          .startOf('month')
          .startOf('day')
          .format(),
      },
      headers: [
        {
          text: '@debtsList/isDefaultColumnHeader',
          value: 'isDefault',
          format: (val) => !!val,
        },
        ...defaultHeaders,
        {
          text: '',
          align: 'right',
          sortable: false,
          actions: (row) => [{ icon: 'description', to: `/contract/${row.contractId}` }],
          value: '&nbsp;',
        },
      ],
      date: null,
      dateModal: false,
    };
  },

  watch: {
    date(val) {
      this.params.from = moment(val)
        .startOf('day')
        .format();
    },
  },

  computed: {
    dateFormatted() {
      return moment(this.params.from).format('DD/MM/YYYY');
    },
    translatedHeaders() {
      return Array.isArray(this.headers)
        ? this.headers.map((h) => ({
            ...h,
            text: this.$t(h.text),
          }))
        : [];
    },
  },

  methods: {
    async onBeforeRequest(query) {
      await this.$router.replace({
        name: 'debtsList',
        query: { ...this.$route.query, ...query },
      });
    },
  },

  created() {
    this.params = { ...this.params, ...this.$router.currentRoute.query };
  },

  beforeRouteUpdate(to, from, next) {
    this.params = { ...this.params, ...to.query };
    next();
  },
};
</script>

<style scoped>
.date-picker {
  display: flex;
  justify-content: center;
  align-items: center;
}
.date-title {
  margin-right: 15px;
  color: inherit;
}
</style>
